import React, { useEffect, useState } from "react";
import axios from "axios";
import TopNav from "../../components/navigation/TopNav";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

import StandardScreen, { ScreenContent } from "../../components/layout/StandardScreen";
import Stack from "../../components/layout/Stack";
import Card from "../../components/ui/Card";
import Button from "../../components/ui/Button";
import {
  TableShell,
  Table,
  Th,
  Td,
  NumberTd,
} from "../../components/data/Table";

const narrowShellStyle = {
  width: "100%",
  maxWidth: "720px",
  margin: "0 auto",
};

export default function DriverDashboard() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [wallets, setWallets] = useState([]);

  const fetchWallets = async () => {
    try {
      const res = await axios.get(`${process.env.REACT_APP_API_URL}/driver/available-wallets`);
      const wallets = Array.isArray(res.data) ? res.data : [];

      setWallets(
        wallets.filter((wallet) => wallet?.is_route_money_box)
      );

    } catch {
      setWallets([]);
    }
  };

  useEffect(() => {
    axios.defaults.headers.common["Authorization"] = `Bearer ${localStorage.getItem("token")}`;
    fetchWallets();
  }, []);

  return (
    <StandardScreen
      topNav={<TopNav title={t("driver_dashboard.title")} mode="main" />}
    >
      <ScreenContent>
        <div style={narrowShellStyle}>
          <Stack gap="4">
            <Card title={t("driver_dashboard.title")}>
              <p style={{ margin: 0 }}>
                {t("driver_dashboard.subtitle")}
              </p>

              {wallets.length > 0 ? (
                <TableShell maxHeight="60vh">
                  <Table>
                    <thead>
                      <tr>
                        <Th columnIndex={0} sticky>
                          {t("driver_dashboard.table.wallet")}
                        </Th>

                        <Th align="right">
                          {t("driver_dashboard.table.ticket_balance")}
                        </Th>
                      </tr>
                    </thead>

                    <tbody>
                      {wallets.map((w) => (
                        <tr key={w.wallet_id}>

                          <Td columnIndex={0} sticky>
                            {[
                              w.route_name,
                              w.start_point && w.end_point
                                ? `${w.start_point} → ${w.end_point}`
                                : null,
                              w.is_route_money_box
                                ? t("driver_dashboard.table.route_money_box")
                                : t("driver_dashboard.table.payer_wallet"),
                            ]
                              .filter(Boolean)
                              .join(" | ")}
                          </Td>

                          <NumberTd>{w.ticket_balance}</NumberTd>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                </TableShell>
              ) : (
                <div>{t("driver_dashboard.messages.empty")}</div>
              )}
            </Card>

            <Card>
              <Stack gap="3">
                <h2
                  style={{
                    margin: 0,
                    fontSize: "1.2rem",
                    fontWeight: 700,
                  }}
                >
                  {t("driver_dashboard.frequently_used.title")}
                </h2>

                <p style={{ margin: 0 }}>
                  {t("driver_dashboard.frequently_used.subtitle")}
                </p>

                <Stack gap="2">
                  <Button fullWidth onClick={() => navigate("/driver/collect-on-bus")}>{t("driver_dashboard.frequently_used.label1")} </Button>

                  <Button fullWidth onClick={() => navigate("/driver/from-payers-in-time")}> {t("driver_dashboard.frequently_used.label2")} </Button>

                </Stack>

              </Stack>
            </Card>
          </Stack>
        </div>
      </ScreenContent>
    </StandardScreen>
  );
}